import { render, staticRenderFns } from "./EventDetailRoute.vue?vue&type=template&id=35c309e6&"
import script from "./EventDetailRoute.vue?vue&type=script&lang=ts&"
export * from "./EventDetailRoute.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports